/**
 * Одинаковы ли наборы ключей без учёта порядка и повторов. Ключи сравниваются строками: `1` и `'1'` — один ключ
 * (ключи строк приходят то числом, то строкой). Отсутствующий набор — пустой.
 */
export const sameKeys = (a?: Iterable<unknown> | null, b?: Iterable<unknown> | null): boolean => {
    const left = new Set(Array.from(a ?? [], String));
    const right = new Set(Array.from(b ?? [], String));
    return left.size === right.size && [...left].every((key) => right.has(key));
};
